module.exports = __webpack_public_path__ + "static/hero-homepage-866b1c18d56f7b3ca030ccc2a39f073d.svg";